import parse from "date-fns/parse";
import format from "date-fns/format";
import numeral from "numeral";

String.prototype.toDate = function(): Date {
  let parsed = parse(this);
  return isNaN(parsed.getTime()) ? null : parsed;
};

Date.prototype.format = function(dateFormat): string {
  let dateTimeFormat = dateFormat || "DD/MM/YYYY";
  return format(this, dateTimeFormat);
};

Number.prototype.toCurrency = function(): string {
  return numeral(this).format("$ 0,0.00");
};

Number.prototype.format = function(numberFormat): string {
  return numeral(this).format(numberFormat);
};

Array.prototype.first = function() {
  if(this.length > 0) {
    return this[0];
  } else {
    return null;
  }
};


// WEBPACK FOOTER //
// ./src/utilities/extend.js